import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Api} from '../utils';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Rx';
import {RequestsHandler} from './requests.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class UserService {

  private loggedIn = false;
  public userId = new BehaviorSubject<number>(null);
  public userDetails = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient, private api: Api, private router: Router, private handler: RequestsHandler) {
    this.loggedIn = !!sessionStorage.getItem('auth_token');
  }

  getUser(id) {
    this.userId.next(id);
    return this.http
      .get(this.api.getUrl('admin/users/' + id), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      }).subscribe(data => {
        this.userDetails.next(data);
      });
  }
  getUsers(params) {
    const url = ('admin/users?page=' + params.page + '&size=' + params.size + ((params.filter.length > 0) ? ('&filter=' + params.filter) : '') + ((params.order.length > 0) ? ('&sort=' + params.sort + '&order=' + params.order) : ''));
    return this.http
      .get(this.api.getUrl(url), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  getCompanies(params) {
    const url = ('admin/companies?page=' + params.page + '&size=' + params.size + ((params.filter.length > 0) ? ('&filter=' + params.filter) : '') + ((params.order.length > 0) ? ('&sort=' + params.sort + '&order=' + params.order) : ''));
    return this.http
      .get(this.api.getUrl(url), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
  getDiscount() {
    const url = ('admin/pricing-rules');
    return this.http
      .get(this.api.getUrl(url), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
  getCompleteDetails(id) {
    return this.http
      .get(this.api.getUrl('admin/companies/' + id), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  postDiscount(discount) {
    return this.http
      .post(this.api.getUrl('admin/pricing-rules/'),  JSON.stringify(discount), {headers: this.handler.headers()});
  }

  postUser(user) {
    return this.http
      .post(this.api.getUrl('admin/users/'),  JSON.stringify(user), {headers: this.handler.headers()});
  }

  postCompany(company) {
    return this.http
      .post(this.api.getUrl('admin/companies/'),  JSON.stringify(company), {headers: this.handler.headers()});
  }

  setUser(user) {
    return this.http
      .put(this.api.getUrl('account/profile'),  JSON.stringify(user), {headers: this.handler.headers()})
      // .catch((err: any) => {
      //   // this.handler.handleError(err);
      //   return new Error(err);
      // });
  }

  getStaff(id) {
    return this.http
      .get(this.api.getUrl('account/staff/' + id), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  setCompany(company) {
    return this.http
      .put(this.api.getUrl('admin/companies/' + company.id),  JSON.stringify(company), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
  getCards() {
    return this.http
      .get(this.api.getUrl('account/cards' ), {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }
  setCard(card) {
    return this.http
      .post(this.api.getUrl('account/cards'),  JSON.stringify(card), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
  setDefaultCards(id) {
    return this.http
      .patch(this.api.getUrl('account/cards/' + id), '', {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
  removeCard(id) {
    return this.http
      .delete(this.api.getUrl('account/cards/' + id), {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }


  getAddressBooks(params = {page: 0, size: 25, filter: ''}) {
    let searchParams = new HttpParams();
    if (params.page) {
      searchParams = searchParams.append('page', `${params.page}`);
    }
    if (params.size) {
      searchParams = searchParams.append('size', `${params.size}`);
    }
    if (params.filter && params.filter.length > 0) {
      searchParams = searchParams.append('search', `${params.filter}`);
    }
    return this.http
      .get(this.api.getUrl('account/address'), {headers: this.handler.headers(),
        params: searchParams})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  getAddressBook(id) {
    return this.http
      .get(this.api.getUrl('account/address/' + id), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
  editAddressBook(address) {
    return this.http
      .put(this.api.getUrl('account/address/' + address.id),  JSON.stringify(address), {headers: this.handler.headers()})
      .catch((err: any) => Observable.throw(new Error(err)));
  }
  addAddressBook(address) {
    return this.http
      .post(this.api.getUrl('account/address' ),  JSON.stringify(address), {headers: this.handler.headers()})
      .catch((err: any) => Observable.throw(new Error(err)));
  }
  removeAddressBook(id) {
    return this.http
      .delete(this.api.getUrl('account/address/' + id), {headers: this.handler.headers()})
      .catch((err: any) => Observable.throw(new Error(err)));
  }
  assignUser(company, user) {
    return this.http
      .patch(this.api.getUrl('admin/users/' + company + '/' + user), '', {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
  unassignUser(company, user) {
    return this.http
      .patch(this.api.getUrl('admin/users/' + company + '/' + user + '/unassign'), '', {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
  removeUser(id) {
    return this.http
      .delete(this.api.getUrl('admin/users/' + id), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
  removeCompany(id) {
    return this.http
      .delete(this.api.getUrl('admin/companies/' + id), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  changePassword(pass) {
    return this.http
      .patch(this.api.getUrl('account/password'), pass, {headers: this.handler.headers()});
  }
  getUserOrders(id, page = null, size = null) {
  // &page=' + page + '&size=' + size
    let searchParams = new HttpParams();
    if (page) {
      searchParams = searchParams.append('page', page);
    }
    if (size) {
      searchParams = searchParams.append('size', size);
    }

    return this.http
      .get(this.api.getUrl(`admin/users/${id}/orders`), {
        headers: this.handler.headers(),
        params: searchParams
      })
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  getUserInactiveProducts(id) {
    return this.http
      .get(this.api.getUrl(`admin/users/${id}/inactive-products`), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  setUserInactiveProducts(id, products) {
    return this.http
      .post(this.api.getUrl(`admin/users/${id}/inactive-products`), {products}, {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  getUserNotes(id, page, size) {
    let searchParams = new HttpParams();
    if (page) {
      searchParams = searchParams.append('page', page);
    }
    if (size) {
      searchParams = searchParams.append('size', size);
    }
    return this.http
      .get(this.api.getUrl(`admin/users/${id}/notes`), {
        headers: this.handler.headers(),
        params: searchParams
      })
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  addUserNote(id, content) {
    return this.http
      .post(this.api.getUrl(`admin/users/${id}/notes`),  JSON.stringify(content), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  editUserNote(userId, noteId, content) {
    return this.http
      .put(this.api.getUrl(`admin/users/${userId}/notes/${noteId}`),  JSON.stringify(content), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  deleteUserNote(userId, noteId) {
    return this.http
      .delete(this.api.getUrl(`admin/users/${userId}/notes/${noteId}`), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts